import {
  CascadiaControlProps,
  CascadiaJsonFormContext,
  withCascadiaControlProps,
} from "@certn/forms";
import { useContext } from "react";

import { FitnessProprietyControl } from "./FitnessProprietyControl";
import { FitnessProprietySummaryControl } from "./FitnessProprietySummaryControl";

function InternalFitnessProprietyControl(props: CascadiaControlProps) {
  const { isSummary } = useContext(CascadiaJsonFormContext);

  if (isSummary) {
    return <FitnessProprietySummaryControl />;
  }

  return <FitnessProprietyControl {...props} />;
}

InternalFitnessProprietyControl.displayName = "FitnessProprietyControl";
export const FitnessProprietyControlRenderer = withCascadiaControlProps(
  InternalFitnessProprietyControl
);
